import { combineReducers } from "redux";
import AuthUserDetailsReducer from "./AuthUserDetailsReducer";
import AgencyDetailsReducer from "./AgencyDetailsReducer";
import FormReducer from "./FormReducer";
import DocumentReducer from "./DocumentReducer";
import GetReducer from "./GetReducer";
import CategoryReducer from "./CategoryReducer";
import CustomerFormReducer from "./customerFormReducer";
import Dogreducer from "./Dogreducer";
import ChoosePlanReducer from "./ChoosePlanReducer";
import Dogdetails from "./Dogdetails";
import Agencydelete from "./Agencydelete";
import DogPlanDetailsReducer from "./DogPlanDetailsReducer";
import FieldValidateReducer from "./FieldValidateReducer";
const RootReducer = combineReducers({
  AuthUserDetailsReducer,
  Agencydelete,
  FormReducer,
  Dogdetails,
  GetReducer,
  Dogreducer,
  AgencyDetailsReducer,
  DocumentReducer,
  CategoryReducer,
  CustomerFormReducer,
  ChoosePlanReducer,
  DogPlanDetailsReducer,
  FieldValidateReducer,
});

export default RootReducer;
